export const normalizeNumericPercent = (value: unknown): number => {
  if (typeof value !== "string" && typeof value !== "number") return 0;

  const normalized = String(value).trim();
  if (!normalized) return 0;

  const match = normalized.match(/(-?\d+(?:\.\d+)?)\s*%?/i);
  if (!match) return 0;

  const numeric = Number(match[1]);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const normalizeTemperature = (value: unknown): number => {
  if (typeof value !== "string" && typeof value !== "number") return 0;

  const normalized = String(value).trim();
  if (!normalized) return 0;

  const match = normalized.match(/(-?\d+(?:\.\d+)?)\s*(?:°|deg|c)?/i);
  if (!match) return 0;

  const numeric = Number(match[1]);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const normalizeDiskUsage = (value: unknown): number => {
  return normalizeNumericPercent(value);
};

export const formatDisplayNumber = (value: number, digits = 2) => {
  return Number.isFinite(value) ? value.toFixed(digits) : "0.00";
};
